export default __webpack_public_path__ + "static/media/Wacky-duck-about.6c118f4b.png";